module.exports = __webpack_public_path__ + "img/Vector_50_9259.aab42496.png";